import * as actionNames from 'action-names'

function fetchBasicActionsFor(resourceName: string, prefix?: string) {
  if (resourceName === null) throw new Error('fetchBasicActionsFor: Expected resourceName')

  const actionTypes = actionNames(resourceName);
  const result = {
    fetchStart: actionTypes.fetchStart,
    fetchSuccess: actionTypes.fetchSuccess,
    fetchError: actionTypes.fetchError
  }

  if (prefix) {
    const upperPrefix = prefix.trim().toUpperCase()
    result.fetchStart = `${upperPrefix}/${result.fetchStart}`
    result.fetchSuccess = `${upperPrefix}/${result.fetchSuccess}`
    result.fetchError = `${upperPrefix}/${result.fetchError}`
  }

  return {...result}
}

export default fetchBasicActionsFor
